export default __webpack_public_path__ + "static/project-dashboard-2e6f19f903cb112cd388f06017c6e317.jpg";